interface UseProfileSectionOptions<TInput, TOutput = TInput> {
  data: TInput[] | undefined
  isLoading: boolean
  isError: boolean
  limit?: number
  extractItem?: (item: TInput) => TOutput
}

interface UseProfileSectionReturn<TOutput> {
  items: TOutput[]
  isEmpty: boolean
  hasMore: boolean
  shouldShowSkeleton: boolean
}

export const useProfileSection = <TInput, TOutput = TInput>({
  data = [],
  isLoading,
  isError,
  limit = 3,
  extractItem = (item): TOutput => item as unknown as TOutput,
}: UseProfileSectionOptions<TInput, TOutput>): UseProfileSectionReturn<TOutput> => {
  const items = data.map(extractItem).slice(0, limit)
  const isEmpty = !isLoading && !isError && data.length === 0
  const hasMore = data.length > limit
  const shouldShowSkeleton = isLoading || isError

  return { items, isEmpty, hasMore, shouldShowSkeleton }
}
